import React, { useEffect, useState, useRef } from "react";
import { Form, FormGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaSearch } from "react-icons/fa";
import styled from "styled-components";
import breakpoints from "../../../constants/breakpoints";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import environment from "../../../environment";
const Styles = styled.div`
  .search-container {
    transition: all 0.3s ease;
    height: 30px;
  }
  input {
    border: 0px;
    text-align: end;
    margin-inline-end: 5px;
    @media (max-width: ${breakpoints.xl}) {
      margin-inline-start: 5px;
      margin-inline-end: 0;
    }
    padding-inline-end: 10px;
    background-color: var(--white);
    color: var(--main-red);
    min-height: unset;
    border-radius: var(--border-radius) !important;
    transition: all 0.3s ease;
    animation: slideIn 0.3s ease;
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(${({ isAR }) => (isAR ? "20px" : "-20px")});
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  input::placeholder {
    text-align: end;
    color: var(--main-red);
  }
  input:focus {
    border: 0px;
    background-color: var(--white) !important;
    color: var(--main-red);
    box-shadow: 0 0 0 0rem rgba(13, 110, 253, 0.25);
  }

  .icon {
    margin-top: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon:hover {
    cursor: pointer;
  }
  @media (min-width: ${breakpoints.xl}) {
    .search-container {
      width: 90%;
    }
    input::placeholder {
      text-align: start;
    }
    .icon {
      margin-top: 0rem;
    }
  }
`;

const NavSearchInput = () => {
  const { t, i18n } = useTranslation();
  const [textToSearch, setTextToSearch] = useState("");
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const isXl = useMediaQuery({ query: `(max-width: ${breakpoints.xl})` });
  const navigation = useNavigate();
  const location = useLocation();
  const searchRef = useRef(null);

  const currentPath = window.location.pathname;
  const searchPath = "/search/";

  const toggleSearch = () => {
    setIsSearchVisible(!isSearchVisible);
  };

  const goToSearchPage = () => {
    if (textToSearch) {
      if (currentPath.startsWith(searchPath)) {
        const newPath = currentPath.replace(
          /\/search\/[^/]+/,
          `/search/${textToSearch}`
        ); // يستبدل الجزء المتكرر من الرابط بالقيمة الجديدة
        navigation(newPath, { replace: false });
      } else {
        navigation(`/search/${textToSearch}`, { replace: false });
      }
    }
    setIsSearchVisible(false);
  };
  const handleSearchChange = (e) => {
    if (e.key === "Enter") {
      goToSearchPage();
      localStorage.removeItem(environment?.Keyword);
    }
  };
  useEffect(() => {
    const searchValue = decodeURIComponent(
      location.pathname.split("/search/")[1]
    );
    if (searchValue && searchValue !== "undefined") {
      setTextToSearch(searchValue);
    }
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsSearchVisible(false);
      }
    };

    if (isSearchVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSearchVisible]);
  return (
    <Styles isAR={i18n?.language === "ar"}>
      <FormGroup ref={searchRef} className="d-flex search-container">
        {isXl && (
          <div
            onClick={isSearchVisible ? goToSearchPage : toggleSearch}
            className="icon"
          >
            <FaSearch size="1.2rem" color="#fff" />
          </div>
        )}
        {isSearchVisible && (
          <Form.Control
            color="whites"
            name="search"
            type="text"
            value={textToSearch}
            className={`rounded-0`}
            onKeyDown={handleSearchChange}
            size={"sm"}
            onChange={(e) => setTextToSearch(e.target.value)}
            autoFocus
          ></Form.Control>
        )}
        {!isXl && (
          <div
            onClick={isSearchVisible ? goToSearchPage : toggleSearch}
            className="icon"
          >
            <FaSearch size="1.2rem" color="var(--white)" />
          </div>
        )}
      </FormGroup>
    </Styles>
  );
};

export default NavSearchInput;
